// Supplerende norske oversettelser: fyller hullene der ra-language-norwegian,
// ra-supabase og Atomics CRM-kataloger ellers faller tilbake til engelsk.
// Merges inn FØR norwegianCrmMessages, slik at de kuraterte strengene der
// vinner ved eventuell overlapp. Hold denne i synk når nye engelske nøkler
// dukker opp (kjør nøkkel-diffen i utviklerverktøyene).

export const norwegianExtraMessages = {
  ra: {
    action: {
      clear_array_input: "Tøm listen",
      create_item: "Opprett %{item}",
      remove_all_filters: "Fjern alle filtre",
      reset: "Nullstill",
      search_columns: "Søk i kolonner",
      select_all_button: "Velg alle",
      select_row: "Velg denne raden",
      expand: "Utvid",
      open_menu: "Åpne meny",
      close_menu: "Lukk meny",
      update: "Oppdater",
      move_up: "Flytt opp",
      move_down: "Flytt ned",
      toggle_theme: "Bytt lyst/mørkt tema",
      select_columns: "Kolonner",
      update_application: "Last inn appen på nytt",
    },
    boolean: {
      null: " ",
    },
    page: {
      empty: "Ingen %{name} ennå.",
      invite: "Vil du legge til en?",
      access_denied: "Ingen tilgang",
      authentication_error: "Autentiseringsfeil",
    },
    input: {
      password: {
        toggle_visible: "Skjul passord",
        toggle_hidden: "Vis passord",
      },
    },
    message: {
      access_denied: "Du har ikke tilgang til å se denne siden",
      authentication_error:
        "Autentiseringstjeneren returnerte en feil, og legitimasjonen din kunne ikke kontrolleres.",
      auth_error:
        "Det oppstod en feil under validering av autentiseringstokenet.",
      bulk_update_content:
        "Er du sikker på at du vil oppdatere %{name} %{recordRepresentation}? |||| Er du sikker på at du vil oppdatere disse %{smart_count} elementene?",
      bulk_update_title:
        "Oppdater %{name} %{recordRepresentation} |||| Oppdater %{smart_count} %{name}",
      clear_array_input: "Er du sikker på at du vil tømme hele listen?",
      select_all_limit_reached:
        "Det er for mange elementer til å velge alle. Bare de første %{max} elementene ble valgt.",
      unsaved_changes:
        "Noen av endringene dine ble ikke lagret. Er du sikker på at du vil forkaste dem?",
      placeholder_data_warning: "Nettverksproblem: Kunne ikke oppdatere data.",
    },
    navigation: {
      clear_filters: "Tøm filtre",
      no_filtered_results: "Fant ingen %{name} med gjeldende filtre.",
      partial_page_range_info:
        "%{offsetBegin}-%{offsetEnd} av mer enn %{offsetEnd}",
      current_page: "Side %{page}",
      page: "Gå til side %{page}",
      first: "Gå til første side",
      last: "Gå til siste side",
      previous: "Gå til forrige side",
      skip_nav: "Hopp til innhold",
    },
    sort: {
      sort_by: "Sorter etter %{field_lower_first} %{order}",
      ASC: "stigende",
      DESC: "synkende",
    },
    auth: {
      auth_check_error: "Logg inn for å fortsette",
    },
    notification: {
      i18n_error: "Kan ikke laste oversettelsene for valgt språk",
      logged_out: "Økten din er avsluttet. Logg inn på nytt.",
      not_authorized: "Du har ikke tilgang til denne ressursen.",
      application_update_available: "En ny versjon er tilgjengelig.",
      offline: "Ingen tilkobling. Kunne ikke hente data.",
    },
    validation: {
      unique: "Må være unik",
    },
    saved_queries: {
      label: "Lagrede søk",
      query_name: "Søknavn",
      new_label: "Lagre gjeldende søk ...",
      new_dialog_title: "Lagre gjeldende søk som",
      remove_label: "Fjern lagret søk",
      remove_label_with_name: 'Fjern søket "%{name}"',
      remove_dialog_title: "Fjerne lagret søk?",
      remove_message:
        "Er du sikker på at du vil fjerne dette elementet fra listen over lagrede søk?",
      help: "Filtrer listen og lagre dette søket til senere",
    },
    guesser: {
      empty: {
        title: "Ingen data å vise",
        message: "Sjekk dataleverandøren din",
      },
    },
    configurable: {
      customize: "Tilpass",
      configureMode: "Konfigurer denne siden",
      inspector: {
        title: "Inspektør",
        content:
          "Hold pekeren over elementene i grensesnittet for å konfigurere dem",
        reset: "Nullstill innstillinger",
        hideAll: "Skjul alle",
        showAll: "Vis alle",
      },
      Datagrid: {
        title: "Datatabell",
        unlabeled: "Kolonne uten navn #%{column}",
      },
      SimpleForm: {
        title: "Skjema",
        unlabeled: "Felt uten navn #%{input}",
      },
      SimpleList: {
        title: "Liste",
        primaryText: "Primærtekst",
        secondaryText: "Sekundærtekst",
        tertiaryText: "Tertiærtekst",
      },
    },
  },
  "ra-supabase": {
    auth: {
      email: "E-post",
      confirm_password: "Bekreft passord",
      sign_in_with: "Logg inn med %{provider}",
      forgot_password: "Glemt passord?",
      reset_password: "Tilbakestill passord",
      password_reset:
        "Passordet ditt er tilbakestilt. Du får en e-post med en lenke for å logge inn.",
      missing_tokens: "Tilgangs- og oppdateringstoken mangler",
      back_to_login: "Tilbake til innlogging",
    },
    reset_password: {
      forgot_password: "Glemt passord?",
      forgot_password_details: "Skriv inn e-posten din for instruksjoner.",
    },
    set_password: {
      new_password: "Velg passordet ditt",
    },
    validation: {
      password_mismatch: "Passordene er ikke like",
    },
  },
  crm: {
    command: {
      placeholder: "Søk eller naviger ...",
      empty: "Ingen treff",
      navigate: "Gå til",
      create: "Opprett",
    },
    custom_fields: {
      title: "Egendefinerte felt",
      save: "Lagre felt",
      manage: "Egendefinerte felt",
    },
    customer: {
      color: "Farge",
      info_tab: "Kundeinfo",
      new_project: "Nytt prosjekt",
      new_task: "Ny oppgave",
      new_contact: "Ny kontakt",
      rename: "Endre navn",
      edit: "Rediger",
    },
    own_company: {
      title: "Min bedrift",
    },
    summary: {
      title: "Kundestatus",
      owner: "Ansvarlig",
      no_owner: "Ingen ansvarlig",
      last_contact: "Sist kontakt",
      no_contact: "Ingen registrert kontakt",
      company_note: "Kundenotat",
      contact_note: "Kontaktnotat",
      next_step: "Neste steg",
      no_next_step: "Ikke satt",
      overdue: "Forfalt",
      open_deals:
        "%{smart_count} åpen mulighet |||| %{smart_count} åpne muligheter",
      active_projects:
        "%{smart_count} aktivt prosjekt |||| %{smart_count} aktive prosjekter",
    },
    contact_log: {
      title: "Registrer kontakt",
      description: "Kontakten teller som sist kontakt og vises i tidslinjen.",
      type: "Type",
      when: "Når",
      contact: "Kontaktperson",
      deal: "Mulighet",
      none: "Ingen valgt",
      note: "Hva ble sagt",
      with_next_step: "Sett nytt neste steg",
      save: "Registrer",
      saved: "Kontakten er registrert",
      next_step_failed:
        "Kontakten er lagret, men neste steg ble ikke lagret: %{error}",
      types: {
        call: "Samtale",
        meeting: "Møte",
        email: "E-post",
        other: "Annen kontakt",
      },
    },
    next_step: {
      dialog_title: "Neste steg",
      dialog_description: "Det forrige steget blir liggende i historikken.",
      mode_step: "Neste steg",
      mode_none: "Ingen planlagt steg",
      description: "Hva skal skje",
      description_placeholder: "F.eks. send tilbud på ny nettside",
      owner: "Ansvarlig",
      no_owner: "Ingen",
      due_date: "Dato",
      reason: "Begrunnelse",
      reason_placeholder: "F.eks. venter på budsjett til januar",
      history: "Historikk",
      none_with_reason: "Ingen planlagt steg: %{reason}",
      outcome_done: "fullført",
      outcome_replaced: "erstattet",
      saved: "Neste steg er lagret",
      completed: "Neste steg er fullført",
      complete: "Fullfør",
      change: "Endre",
      set: "Sett neste steg",
    },
    company_notes: {
      title: "Notater",
      add: "Legg til notat",
      placeholder: "Skriv et notat ...",
      empty: "Ingen notater ennå.",
      follow_up: "Oppfølging",
      overdue: "forfalt",
      complete_follow_up: "Fullfør oppfølging",
      follow_up_completed: "Oppfølgingen er fullført",
      follow_up_complete_failed:
        "Kunne ikke fullføre oppfølgingen. Den står fortsatt i Å gjøre.",
    },
    company_products: {
      title: "Produkter",
      add: "Legg til produkt",
      edit: "Rediger produkt",
      remove: "Fjern produkt",
      remove_confirm:
        "Fjerne produktet fra kunden? Selve produktet beholdes i registeret.",
      empty: "Ingen produkter ennå.",
      price_fallback: "Tomt = produktets utsalgspris",
      cost_fallback: "Tomt = produktets innkjøpspris",
      price_overridden: "Avtalt pris (overstyrer produktets pris)",
      per_month: "per mnd",
      totals: {
        monthly: "Per måned",
        yearly: "Per år",
        one_time: "Engangs",
        price: "Pris",
        cost: "Kost",
        margin: "Margin",
      },
    },
    sales: {
      title: "Pipeline",
    },
    dashboard: {
      internal: "Internt",
      greeting: {
        morning: "God morgen",
        day: "God dag",
        evening: "God kveld",
        night: "God natt",
      },
      kpi: {
        hours_this_week: "Timer denne uken",
        active_projects: "Aktive prosjekter",
        overdue_tasks: "Forfalte oppgaver",
        due_this_week: "Forfaller denne uken",
      },
      shared_note: {
        title: "Delte notater",
        placeholder: "Skriv noe alle i teamet ser ...",
        empty: "Ingen delte notater ennå. Klikk for å skrive.",
        last_edited: "Sist endret av",
      },
      links: {
        title: "Lenker",
        label: "Navn (valgfritt)",
        url: "https://...",
        add: "Legg til",
        empty: "Ingen lenker ennå.",
      },
      overdue: {
        title: "Forfalte oppgaver",
        empty: "Ingen forfalte oppgaver.",
      },
      active_projects: {
        title: "Aktive prosjekter",
        empty: "Ingen aktive prosjekter.",
      },
      follow_ups: {
        title: "Kommende oppfølginger",
        empty: "Ingen kommende oppfølginger.",
      },
    },
    project: {
      rename: "Endre navn",
      assignee: "Ansvarlig",
      no_assignee: "Ingen",
      statuses: "Statuser",
      no_statuses: "Ingen statuser ennå.",
    },
    list: {
      assignee: "Ansvarlig",
      priority: "Prioritet",
      estimate: "Estimat",
      timer: "Timer",
      tracked: "Registrert tid",
      tracked_hours: "Registrert tid, timer",
      tracked_minutes: "Registrert tid, minutter",
      sum: "Sum",
      sum_page: "Sum denne siden",
      add_subtask: "Ny deloppgave",
      show_completed: "Vis fullførte",
      resize_column: "Endre kolonnebredde",
      due_date: "Frist",
    },
    time: {
      title: "Tid",
      start: "Start timer",
      tracked: "Sporet",
      billable: "Fakturerbart",
      estimate: "Estimat",
      note: "Notat",
      add: "Legg til",
    },
    filters: {
      search: "Søk i oppgaver",
      unassigned: "Uten ansvarlig",
      due_all: "Alle frister",
      due_overdue: "Forfalt",
      due_week: "Denne uken",
      due_none: "Uten frist",
      clear: "Nullstill",
      no_matches: "Ingen oppgaver matcher filteret.",
    },
    settings: {
      sections: {
        account: "Konto",
        error_log: "Feillogg",
      },
      account: {
        company_name: "Bedriftsnavn",
        company_name_help:
          "Navnet på din egen bedrift. Brukes som standardnavn for «Min bedrift».",
        time_billable_default: "Tid er fakturerbar som standard",
      },
      companies: {
        colors: "Farger",
        colors_help: "Fargene en kunde kan tildeles.",
      },
      projects: {
        global_statuses: "Statuser for oppgaver på kundenivå",
        global_statuses_help:
          "Én felles liste for hele instansen. Endringer her slår inn med én gang – dette er statusene oppgavene som ligger rett på kunden faktisk bruker.",
        statuses: "Prosjektstatuser",
        statuses_help:
          "Standardstatuser nye prosjekter starter med. Statuser som legges til her, legges også inn i eksisterende prosjekter og den globale lista over — omdøp og sletting gjelder bare nye prosjekter.",
        statuses_propagated:
          "Nye statuser er også lagt til i eksisterende prosjekter og den globale lista",
        statuses_propagate_error:
          "Malen ble lagret, men de nye statusene kunne ikke legges inn i eksisterende statuslister",
      },
    },
    error_log: {
      all: "Alle",
      empty: "Ingen feil registrert.",
      help: "Feil de siste %{days} dagene. Brukeren ser referansen (F-…) i feilmeldingen; søk etter den her. Bare en kort, renset feiltekst lagres.",
      unavailable: "Feilloggen kan ikke leses akkurat nå.",
      network: "Nettverk",
      validation: "Validering",
      access: "Tilgang",
      billing: "Uklart fakturautfall",
      unknown: "Annet",
    },
    tripletex_sync: {
      menu: "Synk fra Tripletex",
      title: "Synk fra Tripletex",
      content:
        "Tripletex er master for stamdata: navn, kundenummer, adresser og priser overskrives i Mimin. Notater, oppfølging og produktkoblinger per kunde røres ikke.",
      confirm: "Kjør synk",
      recheck: "Sjekk på nytt",
      syncing: "Synker …",
      preview_customers: "Kunder",
      preview_products: "Produkter",
      preview_contacts: "Kontakter",
      preview_twin_hint:
        "Skal noen av disse matche en eksisterende Mimin-kunde? Sett kundenummeret på Mimin-kunden og sjekk på nytt – ellers opprettes de som nye kort.",
      // Merk: tellermeldingene («done», preview_*_counts) bygges i
      // komponentene og sendes som inline-fallback – ingen katalognøkler,
      // ellers vinner de over tellerne.
    },
    invoice_basis: {
      title: "Fakturagrunnlag",
      show_entries: "Vis timeføringene",
      entries_description:
        "Timeføringene bak linjen. Åpne oppgaven for å endre en føring.",
      entries_empty: "Ingen timeføringer igjen på linjen.",
      open_task: "Åpne oppgaven",
      delete_entry: "Slett timeføring",
      delete_entry_title: "Slette timeføringen?",
      delete_entry_content:
        "Føringen fjernes fra oppgaven og fakturagrunnlaget. Dette kan ikke angres.",
      entry_deleted: "Timeføringen er slettet",
      whole_month: "Hel måned",
      custom_period: "Egendefinert periode",
      period_kind: "Periodetype",
      previous_month: "Forrige måned",
      next_month: "Neste måned",
      custom_not_sendable:
        "Egendefinert periode – kan ikke sendes. Velg en hel måned for å sende til Tripletex.",
      before_journal_start:
        "Før første journalmåned (%{month}): løpende avtaler regnes som fakturert og er ikke med. Timer og engangsprodukter kan ikke sendes til Tripletex, men du kan bruke «Marker som fakturert» for det som allerede er fakturert.",
      journal_inactive:
        "Fakturajournalen er ikke aktivert. Sett første journalmåned under Innstillinger → Fakturering.",
      journal_only: "Bare journal",
      open_sync: "Sjekk match og synk",
      previous_quantity:
        "Etterregistrering: %{quantity} %{unit} er sendt før i måneden; antallet er differansen etter avrunding av summen.",
      settings_summary:
        "Timer rundes opp til nærmeste %{unit} min per linje · mva på timer %{vat} %",
      incomplete: "Ufullstendig grunnlag – kan ikke sendes",
      load_failed: "Fakturagrunnlaget kunne ikke hentes.",
      internal_entries:
        "%{smart_count} timeføring på egen bedrift er internt arbeid og faktureres ikke. |||| %{smart_count} timeføringer på egen bedrift er internt arbeid og faktureres ikke.",
      running_entries:
        "%{smart_count} timer går fortsatt og er ikke med før den stoppes. |||| %{smart_count} timere går fortsatt og er ikke med før de stoppes.",
      missing_link: "Mangler Tripletex-kobling",
      blocked: "Avvik må rettes",
      free: "Gratis",
      actual: "faktisk %{duration}",
      missing_rate: "Mangler sats",
      unknown: "Ukjent",
      empty: "Ingen ufakturerte linjer i perioden.",
      skipped:
        "%{count} ufakturerte timeføringer mangler kunde og er ikke med i grunnlaget. Finn oppgavene deres og sett kunde.",
      total: "Sum grunnlag (eks. mva)",
      mark_invoiced: "Marker som fakturert",
      mark_invoiced_title: "Marker som fakturert?",
      mark_invoiced_content:
        "Ingen kladd lages i Tripletex. Linjene til %{name} føres i fakturajournalen som manuelt fakturert og kan ikke sendes på nytt. Bruk dette bare når fakturaen faktisk er laget utenom Mimin.",
      marked: "Markert som fakturert",
      tripletex_send: "Fakturakladd i Tripletex",
      tripletex_title: "Opprett fakturakladd i Tripletex?",
      tripletex_content:
        "Serveren beregner grunnlaget for %{name} på nytt, reserverer linjene i journalen og sender dem til Tripletex som en ordrekladd du fakturerer derfra. Er utfallet uklart, må eksporten avklares i journalen før ny sending.",
      tripletex_created:
        "Ordrekladd %{reference} opprettet i Tripletex. Linjene er markert som fakturert.",
      bulk_select: "Ta med i masseopprettelsen",
      bulk_send: "Opprett fakturakladder (%{count})",
      bulk_running: "Oppretter … (%{done}/%{total})",
      bulk_title: "Opprett fakturakladder i Tripletex?",
      bulk_confirm: "Opprett fakturakladder",
      bulk_content:
        "Oppretter fakturakladd i Tripletex for %{smart_count} kunde (%{sum}). Hver kunde får sin egen eksport i journalen med eget utfall. |||| Oppretter fakturakladder i Tripletex for %{smart_count} kunder (%{sum}). Hver kunde får sin egen eksport i journalen med eget utfall.",
      bulk_ok: "Kladd %{reference} opprettet",
      lost_response: "%{message} Sjekk journalen under før du prøver igjen.",
      bulk_result_title: "Fakturakladder opprettet",
      bulk_result_summary: "%{ok} opprettet, %{failed} feilet.",
      already_invoiced:
        "%{smart_count} timeføring i perioden er allerede fakturert |||| %{smart_count} timeføringer i perioden er allerede fakturert",
      type_hours: "Timer",
      type_recurring: "Produkt",
      type_one_time: "Engangs",
      journal: {
        open_elsewhere:
          "%{smart_count} eksport i en annen måned må avklares. |||| %{smart_count} eksporter i andre måneder må avklares.",
        lines: "%{smart_count} linje |||| %{smart_count} linjer",
      },
      csv: {
        customer_number: "Kundenr",
        type: "Type",
        description: "Beskrivelse",
        actual_hours: "Faktisk tid (t)",
        quantity: "Fakturerbart antall",
        unit: "Enhet",
        price: "Pris",
        vat: "Mva %",
        amount: "Beløp",
        issue: "Avvik",
      },
    },
    reports: {
      title: "Rapporter",
      from: "Fra",
      to: "Til",
      customer: "Kunde",
      project: "Prosjekt",
      assignee: "Ansvarlig",
      all: "Alle",
      n_selected: "%{smart_count} valgt",
      clear: "Nullstill",
      this_week: "Denne uken",
      this_month: "Denne måneden",
      last_month: "Forrige måned",
      total: "Total",
      billable: "Fakturerbart",
      non_billable: "Ikke fakturerbart",
      billable_short: "fakt.",
      by_customer: "Per kunde",
      by_user: "Per bruker",
      no_customer: "Uten kunde",
      no_project: "Uten prosjekt",
      empty: "Ingen tid sporet i denne perioden.",
      revenue: "Omsetning",
      cost: "Kostnad",
      margin: "Margin",
      hour_value: "Timeverdi",
      actual_total: "Faktisk tid",
      billable_rounded: "Fakturerbart antall (%{unit} min)",
      unknown_margin: "Ukjent margin",
      unknown_margin_help: "%{duration} mangler time- eller kostpris",
      current_rates:
        "Beregnet med dagens satser – ikke faktisk fakturert omsetning. Timer uten sats er ikke med, og margin er ukjent der satsen mangler.",
      missing_rate_time: "%{duration} fakturerbar tid mangler timepris.",
      missing_cost_time: "%{duration} mangler kostpris.",
      load_failed: "Rapporten kunne ikke hentes komplett.",
      export: "Eksporter CSV",
      csv: {
        date: "Dato",
        amount: "Beløp",
        hour_value: "Timeverdi (dagens sats)",
        cost: "Kostnad",
        margin: "Margin",
        task: "Oppgave",
        user: "Person",
        hours: "Timer",
        note: "Notat",
        yes: "Ja",
        no: "Nei",
      },
    },
  },
  resources: {
    companies: {
      fields: {
        email: "E-postadresse",
        customer_number: "Kundenummer",
        tax_identifier: "Organisasjonsnummer",
      },
      archive: {
        archive: "Arkiver kunde",
        restore: "Gjenopprett",
        archived: "Kunde arkivert",
        restored: "Kunde gjenopprettet",
        view: "Arkiverte kunder",
        list_title: "Arkiverte kunder",
        empty: "Ingen arkiverte kunder.",
        archive_selected: "Arkiver valgte",
        n_selected: "%{smart_count} valgt",
        archived_many: "%{smart_count} kunder arkivert",
      },
      import: {
        title: "Importer kunder fra Tripletex",
        button: "Importer kunder",
        hint: "Last opp kunde- og leverandøreksporten fra Tripletex (CSV). Kunder kobles på kundenummer: finnes kunden, oppdateres den, ellers opprettes den. Postadressen brukes, og mobilnummer prioriteres foran fasttelefon. Arkiverte kunder blir ikke endret.",
      },
      enrich: {
        button: "Berik fra BRREG",
        title: "Berik kunder fra BRREG?",
        content:
          "Slår opp alle kunder som har organisasjonsnummer, men mangler bransje, i Brønnøysundregistrene og fyller inn tomme felter (bransje, størrelse, adresse). Utfylte felter røres ikke.",
        success:
          "Berikelse fullført: %{updated} oppdatert, %{skipped} hoppet over, %{notFound} ikke funnet i BRREG (%{scanned} gjennomgått).",
        error: "Kunne ikke berike kunder fra BRREG",
      },
    },
    projects: {
      fields: {
        assignee_id: "Ansvarlig",
      },
    },
    work_items: {
      mine: "Mine oppgaver",
      subtasks: {
        title: "Deloppgaver",
        add: "Ny deloppgave",
      },
      bulk: {
        complete: "Fullfør",
        completed:
          "%{smart_count} oppgave fullført |||| %{smart_count} oppgaver fullført",
        assigned:
          "Ansvarlig satt på %{smart_count} oppgave |||| Ansvarlig satt på %{smart_count} oppgaver",
        status_set:
          "Status satt på %{smart_count} oppgave |||| Status satt på %{smart_count} oppgaver",
        priority_set:
          "Prioritet satt på %{smart_count} oppgave |||| Prioritet satt på %{smart_count} oppgaver",
        due_set:
          "Frist satt på %{smart_count} oppgave |||| Frist satt på %{smart_count} oppgaver",
        mixed_scope:
          "Statusene hører til hvert sitt prosjekt. Velg oppgaver fra ett og samme sted.",
      },
    },
    contacts: {
      field_categories: {
        background_info: "Bakgrunnsinfo",
        identity: "Identitet",
        misc: "Diverse",
        personal_info: "Personlig informasjon",
        position: "Stilling",
      },
      action: {
        export_vcard: "Eksporter til vCard",
      },
      background: {
        last_activity_on: "Siste aktivitet %{date}",
        added_on: "Lagt til %{date}",
        followed_by: "Fulgt av %{name}",
        followed_by_you: "Fulgt av deg",
        status_none: "Ingen",
      },
      position_at: "%{title} hos",
      position_at_company: "%{title} hos %{company}",
      import: {
        title: "Importer kontakter",
        button: "Importer CSV",
        hint: "Fila må ha en overskriftsrad. Kolonnene kjennes igjen på navn, som Fornavn, Etternavn, Kunde, E-post og Telefon. Kontakter med en e-postadresse som allerede finnes, hoppes over, og kunder og stikkord som mangler, opprettes.",
        template: "Last ned mal",
      },
      inputs: {
        genders: {
          male: "Han/ham",
          female: "Hun/henne",
          nonbinary: "Hen/hen",
        },
        personal_info_types: {
          work: "Jobb",
          home: "Privat",
          other: "Annet",
        },
      },
      list: {
        error_loading: "Feil ved lasting av kontakter",
      },
      bulk_tag: {
        action: "Merk",
        back: "Tilbake til etiketter",
        create_description:
          "Opprett en ny etikett og bruk den på de valgte kontaktene.",
        description:
          "Velg en eksisterende etikett eller opprett en ny for de valgte kontaktene.",
        empty:
          "Ingen etiketter ennå. Opprett en for å merke de valgte kontaktene.",
        error: "Kunne ikke legge til etikett på kontaktene",
        noop: "De valgte kontaktene har allerede denne etiketten",
        success:
          "Etikett lagt til %{smart_count} kontakt |||| Etikett lagt til %{smart_count} kontakter",
        title: "Legg til etikett på kontakter",
      },
      merge: {
        action: "Slå sammen med en annen kontakt",
        confirm: "Slå sammen kontakter",
        current_contact: "Gjeldende kontakt (slettes)",
        description: "Slå denne kontakten sammen med en annen.",
        error: "Kunne ikke slå sammen kontaktene",
        merging: "Slår sammen ...",
        no_additional_data: "Ingen ekstra data å slå sammen",
        select_target: "Velg en kontakt å slå sammen med",
        success: "Kontaktene ble slått sammen",
        target_contact: "Målkontakt (beholdes)",
        title: "Slå sammen kontakt",
        warning_description:
          "Alle data overføres til den andre kontakten. Denne handlingen kan ikke angres.",
        warning_title: "Advarsel: Destruktiv handling",
        what_will_be_merged: "Dette slås sammen:",
      },
      filters: {
        before_last_month: "Før forrige måned",
        before_this_month: "Før denne måneden",
        before_this_week: "Før denne uken",
        managed_by_me: "Forvaltet av meg",
        search: "Søk navn, kunde ...",
        this_week: "Denne uken",
        today: "I dag",
        tags: "Etiketter",
        tasks: "Påminnelser",
      },
      hot: {
        empty_change_status:
          'Endre status på en kontakt ved å legge til et notat på kontakten og klikke på "vis valg".',
        empty_hint: 'Kontakter med "het" status vises her.',
        title: "Hete kontakter",
      },
    },
    notes: {
      name: "Notat |||| Notater",
      forcedCaseName: "Notat",
      fields: {
        status: "Status",
        date: "Dato",
        attachments: "Vedlegg",
        contact_id: "Kontakt",
        deal_id: "Mulighet",
      },
      action: {
        add: "Legg til notat",
        add_first: "Legg til ditt første notat",
        delete: "Slett notat",
        edit: "Rediger notat",
        update: "Oppdater notat",
        add_this: "Legg til dette notatet",
      },
      sheet: {
        create: "Opprett notat",
        create_for: "Opprett notat for %{name}",
        edit: "Rediger notat",
        edit_for: "Rediger notat for %{name}",
      },
      deleted: "Notat slettet",
      empty: "Ingen notater ennå",
      author_added: "%{name} la til et notat",
      you_added: "Du la til et notat",
      me: "Meg",
      list: {
        error_loading: "Feil ved lasting av notater",
      },
      note_for_contact: "Notat for %{name}",
      stepper: {
        hint: "Gå til en kontaktside og legg til et notat",
      },
      added: "Notat lagt til",
      inputs: {
        add_note: "Legg til et notat",
        options_hint: "(legg ved filer, eller endre detaljer)",
        show_options: "Vis valg",
      },
      actions: {
        attach_document: "Legg ved dokument",
      },
      validation: {
        note_or_attachment_required: "Et notat eller et vedlegg er påkrevd",
      },
    },
    sales: {
      fields: {
        first_name: "Fornavn",
        last_name: "Etternavn",
        email: "E-post",
        administrator: "Administrator",
        disabled: "Deaktivert",
        hourly_rate: "Timepris",
        hourly_cost: "Kostpris",
        planned_week_hours: "Planlagt uke (timer)",
      },
      create: {
        error: "Det oppstod en feil under oppretting av brukeren.",
        success:
          "Bruker opprettet. De får snart en e-post for å sette passordet sitt.",
        title: "Opprett en ny bruker",
      },
      edit: {
        error: "Det oppstod en feil. Prøv igjen.",
        record_not_found: "Fant ikke posten",
        success: "Brukeren ble oppdatert",
        title: "Rediger %{name}",
      },
      action: {
        new: "Ny bruker",
      },
    },
    tasks: {
      forcedCaseName: "Påminnelse",
      fields: {
        text: "Beskrivelse",
        due_date: "Frist",
        type: "Type",
        contact_id: "Kontakt",
        due_short: "frist",
      },
      action: {
        add: "Legg til påminnelse",
        create: "Opprett påminnelse",
        edit: "Rediger påminnelse",
      },
      actions: {
        postpone_next_week: "Utsett til neste uke",
        postpone_tomorrow: "Utsett til i morgen",
        title: "påminnelseshandlinger",
      },
      added: "Påminnelse lagt til",
      deleted: "Påminnelse slettet",
      dialog: {
        create: "Opprett påminnelse",
        create_for: "Opprett påminnelse for %{name}",
      },
      sheet: {
        edit: "Rediger påminnelse",
        edit_for: "Rediger påminnelse for %{name}",
      },
      empty: "Ingen påminnelser ennå",
      empty_list_hint: "Påminnelser lagt til kontaktene dine vises her.",
      filters: {
        later: "Senere",
        overdue: "Forfalt",
        this_week: "Denne uken",
        today: "I dag",
        tomorrow: "I morgen",
        with_pending: "Med ventende påminnelser",
      },
      regarding_contact: "(Ang.: %{name})",
      updated: "Påminnelse oppdatert",
    },
    tags: {
      action: {
        add: "Legg til etikett",
        create: "Opprett ny etikett",
      },
      dialog: {
        color: "Farge",
        create_title: "Opprett en ny etikett",
        edit_title: "Rediger etikett",
        name_label: "Etikettnavn",
        name_placeholder: "Skriv inn etikettnavn",
      },
    },
  },
};
